/* global importName: false */
import store from '@/services/store'
import { getDeepProperty } from '@/helpers/deepObject.js'

const SettingsLayout = () => importName('@/scenes/Shows/scenes/Settings/components/SettingsLayout.vue', 'settingsLayout')
const SiteSettings = () => importName('@/scenes/Shows/scenes/Site/scenes/SiteSettings/SiteSettings.vue', 'siteSettings')
const SitePages = () => importName('@/scenes/Shows/scenes/Site/scenes/SitePages/SitePages.vue', 'sitePages')
const SiteDesign = () => importName('@/scenes/Shows/scenes/Site/scenes/SiteDesign/SiteDesign.vue', 'siteDesign')
const CreateSiteLink = () => importName('@/scenes/Shows/scenes/Site/scenes/SitePages/scenes/CreateSiteLink.vue', 'sitePagesLink')
const CreateSitePage = () => importName('@/scenes/Shows/scenes/Site/scenes/SitePages/scenes/CreateSitePage.vue', 'sitePagesCreate')

const siteRoutes = [
  {
    path: 'site',
    component: SettingsLayout,
    children: [
      {
        path: 'edit',
        name: 'site-settings',
        component: SiteSettings,
        meta: {
          breadcrumbs: [
            { title: 'Settings' },
            { title: 'Site Settings' }
          ]
        }
      },
      {
        path: 'pages',
        name: 'site-pages',
        component: SitePages,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Links' }
          ]
        }
      },
      {
        path: 'pages/page/new',
        name: 'site-page-create',
        component: CreateSitePage,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Links', to: 'site-pages' },
            { title: 'Add New Page' }
          ]
        }
      },
      {
        path: 'pages/link/new',
        name: 'site-link-create',
        component: CreateSiteLink,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Links', to: 'site-pages' },
            { title: 'Add New Link' }
          ]
        }
      },
      {
        path: 'pages/page/:pageId/edit',
        name: 'site-page-edit',
        component: CreateSitePage,
        props: true,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Links', to: 'site-pages' },
            { title: 'Edit Page' }
          ]
        }
      },
      {
        path: 'pages/link/:pageId/edit',
        name: 'site-link-edit',
        component: CreateSiteLink,
        props: true,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Links', to: 'site-pages' },
            { title: 'Edit Page' }
          ]
        }
      },
      {
        path: 'design',
        name: 'site-design',
        component: SiteDesign,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'site-settings' },
            { title: 'Site Design' }
          ]
        }
      }
    ],
    beforeEnter: async (to, from, next) => {
      // if you don't have can_edit permissions, back to overview for you
      const activePodcastUserPermissions = store.getters.activePodcastUserPermissions
      const canEdit = getDeepProperty(activePodcastUserPermissions, 'can_edit')
      if (!canEdit) {
        next({
          name: 'show-overview'
        })
        return
      }
      next()
    }
  }
]

export default siteRoutes
